import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import { media } from '../../../styles';

import Button from '../../ui/Button';
import ButtonGroup from '../../ui/ButtonGroup';
import Popover from '../../ui/Popover';
import RangeInput from '../../ui/RangeInput';
import SelectField from '../../ui/SelectField';
import Body from '../../typography/Body';
import Headline from '../../typography/Headline';

const personaOptions = [
  {
    label: 'Taking clients',
    value: 'clients',
  },
  {
    label: 'Attending with family',
    value: 'family',
  },
  {
    label: 'A diehard fan',
    value: 'diehard_fan',
  },
  {
    label: 'A casual fan',
    value: 'casual_fan',
  },
  {
    label: 'Just browsing',
    value: 'browsing',
  },
];

const quantityOptions = [
  {
    label: 'any',
  },
  {
    label: '1',
  },
  {
    label: '2',
  },
  {
    label: '3',
  },
  {
    label: '4+',
  },
];

const Row = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 32,
});


const Footer = glamorous.div(props => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 16,
  animationDelay: '1600ms',

  '& > .FooterBrowseAllTickets': {
    marginTop: 16,
  },

  [media('sm')]: {
    flexDirection: 'row-reverse',

    '& > .FooterBrowseAllTickets': {
      marginTop: 0,
      marginRight: 16,
    },
  },
}));

const noop = () => {};

class FiltersPopover extends React.PureComponent {
  static propTypes = {
    onClickBrowseAllTickets: PropTypes.func,
    onClickFindMyTickets: PropTypes.func,

    hasButton: PropTypes.bool,
    isOpen: PropTypes.bool,
  };

  static defaultProps = {
    onClickBrowseAllTickets: noop,
    onClickFindMyTickets: noop,

    hasButton: false,
    isOpen: undefined,
  };

  state = {
    priceLow: this.props.priceLow ? parseInt(this.props.priceLow, 10) : 1,
    priceHigh: this.props.priceHigh ? parseInt(this.props.priceHigh, 10) : 5,
    persona: this.props.persona || '',
    quantity: this.props.quantity || quantityOptions[2].label,
  };

  setPrices = (priceLow, priceHigh) => this.setState({
    priceLow,
    priceHigh,
  });

  setSelectedQuantity = quantity => this.setState({ quantity });

  createHandleClick = (label) => (e) => {
    this.setSelectedQuantity(label);
  };

  handleOk = (e) => {
    if (this.state.persona && this.state.quantity) {
      this.props.onClickFindMyTickets(e, this.state);
    }
  };

  handleClickBrowseAllTickets = (e) => {
    this.props.onClickBrowseAllTickets(e, this.state);
  };


  handleClickFindMyTickets = (e) => {
    this.props.onClickFindMyTickets(e, this.state);
  };

  handleChangePersona = (persona) => {
    this.setState({ persona: persona ? persona.value : null });
  };

  handleChangePriceRange = (values) => {
    const priceLow = values[0];
    const priceHigh = values[1];

    this.setPrices(priceLow, priceHigh);
  };

  renderPopoverOpen = (this.props.hasButton ? handleOpen => (
    <Button onClick={handleOpen}>
      Filters
    </Button>
  ) : null);

  render() {
    return (
      <Popover
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        renderOpen={this.renderPopoverOpen}
        isOpen={this.props.isOpen}
        closeOnClickBackdrop={this.props.canDismiss}
        hasOk={false}
        popoverWidth={480}
      >
        <Headline
          align="center"
          marginTop={0}
          marginBottom={0}
        >
          Filters
        </Headline>
        <Body>Quantity</Body>
        <Row>
          <ButtonGroup>
            {quantityOptions.map(option => (
              <Button
                key={option.label}
                color="primary"
                label={option.label}
                onClick={this.createHandleClick(option.label)}
                isRaised={this.state.quantity === option.label}
                style={{
                  minHeight: 48,
                }}
              />
            ))}
          </ButtonGroup>
        </Row>
        <Body>Price</Body>
        <Row>
          <RangeInput
            min={1}
            max={5}
            defaultValue={[this.state.priceLow, this.state.priceHigh]}
            onChange={this.handleChangePriceRange}
            tipFormatter={(value) => (new Array(value + 1)).join('$')}
          />
        </Row>
        <Body>Select One</Body>
        <Row>
          <SelectField
            name="PersonaSelectField"
            onChange={this.handleChangePersona}
            options={personaOptions}
            placeholder="I am..."
            defaultSelected={this.props.persona}
          />
        </Row>
        <Footer
          className={this.props.isAnimated ? 'animated fadeIn' : undefined}
        >
          <Button
            className="FooterFindMyTickets"
            color="accent"
            label="Find My Tickets"
            isRaised
            onClick={this.handleClickFindMyTickets}
            style={{
              height: 48,
              width: '100%',
            }}
          />
          <Button
            className="FooterBrowseAllTickets"
            color="primary"
            label="Browse All Tickets"
            onClick={this.handleClickBrowseAllTickets}
            style={{
              height: 48,
              width: '100%',
            }}
          />
        </Footer>
      </Popover>
    );
  }
}

export default FiltersPopover;



// WEBPACK FOOTER //
// ./src/components/features/FiltersPopover/FiltersPopover.js